import {ButtonNormal} from './Buttons';

class ListButtons{
  static ButtonNormal = ButtonNormal
}

export default ListButtons
